// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__T0psY","infoArea":"Footer_infoArea__OvIAq","iconsArea":"Footer_iconsArea__GNTWb","icon":"Footer_icon__Zscac","logo":"Footer_logo__+JiYo"};